(() => {
  const animateAnswer = (item, expanded) => {
    const btn = item.querySelector('.mt-faq-accordion__q')
    const answer = item.querySelector('.mt-faq-accordion__a')
    if (!btn || !answer) return

    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false')

    if (answer._animationFrame) {
      cancelAnimationFrame(answer._animationFrame)
    }

    if (expanded) {
      answer.hidden = false
      answer.style.height = '0px'
      item.classList.add('is-open')

      answer._animationFrame = requestAnimationFrame(() => {
        answer.style.height = `${answer.scrollHeight}px`
      })
      return
    }

    answer.style.height = `${answer.scrollHeight}px`
    item.classList.remove('is-open')

    answer._animationFrame = requestAnimationFrame(() => {
      answer.style.height = '0px'
    })
  }

  const initSection = (section) => {
    const items = Array.from(section.querySelectorAll('.mt-faq-accordion__item'))
    if (!items.length) return

    items.forEach((item) => animateAnswer(item, false))

    section.addEventListener('transitionend', (e) => {
      const answer = e.target.closest('.mt-faq-accordion__a')
      if (!answer || e.propertyName !== 'height') return

      const item = answer.closest('.mt-faq-accordion__item')
      if (!item) return

      if (item.classList.contains('is-open')) {
        answer.style.height = 'auto'
      } else {
        answer.hidden = true
      }
    })

    section.addEventListener('click', (e) => {
      const btn = e.target.closest('.mt-faq-accordion__q')
      if (!btn || !section.contains(btn)) return
      const item = btn.closest('.mt-faq-accordion__item')
      if (!item) return
      const expanded = btn.getAttribute('aria-expanded') === 'true'

      items.forEach((other) => {
        if (other !== item) {
          animateAnswer(other, false)
        }
      })

      animateAnswer(item, !expanded)
    })
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.mt-faq-accordion[data-section-id]').forEach(initSection)
  })
})()
